package ru.education.building.schedule.widgets

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.wrapContentSize
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.BiasAlignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.sp
import ru.education.building.schedule.data.repositories.ScheduleRepository
import ru.education.building.schedule.view.states.UiState
import ru.education.building.schedule.view.viewmodels.ScheduleViewModel


@Composable
fun ModalScreen(rp: ScheduleRepository, vm: ScheduleViewModel) {
    val lazyListState = rememberLazyListState()
    val ui by vm.state.collectAsState()

    LaunchedEffect(Unit) {
        vm.loadGroup()
    }

    when (val s = ui) {
        is UiState.Loading -> CircularProgressIndicator(
            modifier = Modifier.fillMaxSize().wrapContentSize(BiasAlignment(0f, -0.2f))
        )
        is UiState.Error -> Text("Ошибка при загрузке расписания, повторите попытку позже", modifier = Modifier.fillMaxSize().wrapContentSize(
            Alignment.TopCenter))
        is UiState.Group -> {
            LazyColumn(
                state = lazyListState,
                modifier = Modifier
                    .fillMaxSize()
                    .wrapContentSize(Alignment.Center)
            ) {
                val dedupedItems = s.items.distinctBy { it.name }
                items(dedupedItems) { item ->
                    Box(
                        contentAlignment = Alignment.Center,
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        Text(
                            text = item.name,
                            fontSize = 20.sp,
                            modifier = Modifier
                                .fillMaxWidth()
                                .wrapContentSize(Alignment.Center)
                                .clickable(onClick = {
                                    // Чтобы не пропало закэшированное расписание при падении api
                                    if (rp.selectedId != item.id && rp.selectedGroup != item.name) {
                                        rp.selectSchedule(emptyList())
                                    }
                                    rp.selectId(item.id)
                                    rp.selectGroup(item.name)
                                    vm.load(item.id)
                                })
                        )
                    }
                    //Box(modifier = Modifier.weight(1f))
                }
            }
        }
        is UiState.Data -> {
            rp.selectSchedule(s.items)
            Text("Расписание загружено!", modifier = Modifier.fillMaxSize().wrapContentSize(Alignment.TopCenter))
        }
    }
}